// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const initialFormValues = Object.freeze({
  antennaCode: '',
  classificationId: '',
  companyName: '',
  diameter: '',
  diameterUnit: 'SI',
  modelNumber: '',
  pagination: null,
})

export default initialFormValues
